import { render, staticRenderFns } from "./printTags.vue?vue&type=template&id=5bdc2a76&scoped=true&"
import script from "./printTags.vue?vue&type=script&lang=js&"
export * from "./printTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdc2a76",
  null
  
)

export default component.exports